import React from 'react'
import anestheticImage from '../svgs/operations/anesthetic.svg'
import appointmentImage from '../svgs/operations/appointment.svg'
import babyTeethImage from '../svgs/operations/babyTeeth.svg'
import bacteriaImage from '../svgs/operations/bacteria.svg'
import badBreathImage from '../svgs/operations/badBreath.svg'
import bondingImage from '../svgs/operations/bonding.svg'
import bracesImage from '../svgs/operations/braces.svg'
import brokenToothImage from '../svgs/operations/brokenTooth.svg'
import calculusImage from '../svgs/operations/calculus.svg'
import contactImage from '../svgs/operations/contact.svg'
import crownImage from '../svgs/operations/crown.svg'
import crowningImage from '../svgs/operations/crowning.svg'
import crowning2Image from '../svgs/operations/crowning2.svg'
import dentistImage from '../svgs/operations/dentist.svg'
import denturesImage from '../svgs/operations/dentures.svg'
import detailsImage from '../svgs/operations/details.svg'
import enamelImage from '../svgs/operations/enamel.svg'
import extractionImage from '../svgs/operations/extraction.svg'
import familyImage from '../svgs/operations/family.svg'
import flossImage from '../svgs/operations/floss.svg'
import forumImage from '../svgs/operations/forum.svg'
import gapImage from '../svgs/operations/gap.svg'
import hygieneImage from '../svgs/operations/hygiene.svg'
import implantImage from '../svgs/operations/implant.svg'
import ledImage from '../svgs/operations/led.svg'
import locationImage from '../svgs/operations/location.svg'
import missingImage from '../svgs/operations/missing.svg'
import mobileImage from '../svgs/operations/mobile.svg'
import mouthWashImage from '../svgs/operations/mouthWash.svg'
import onlineImage from '../svgs/operations/online.svg'
import oralCavityImage from '../svgs/operations/oralCavity.svg'
import oralIrrigatorImage from '../svgs/operations/oralIrrigator.svg'
import perfectImage from '../svgs/operations/perfect.svg'
import protectionImage from '../svgs/operations/protection.svg'
import recordImage from '../svgs/operations/record.svg'
import rootImage from '../svgs/operations/root.svg'
import rottenImage from '../svgs/operations/rotten.svg'
import scalingImage from '../svgs/operations/scaling.svg'
import serviceImage from '../svgs/operations/service.svg'
import sleepingImage from '../svgs/operations/sleeping.svg'
import smileImage from '../svgs/operations/smile.svg'
import snoringImage from '../svgs/operations/snoring.svg'
import toolkitImage from '../svgs/operations/toolkit.svg'
import toothacheImage from '../svgs/operations/toothache.svg'
import toothburshImage from '../svgs/operations/toothbursh.svg'
import toothpasteImage from '../svgs/operations/toothpaste.svg'
import ultrasonicImage from '../svgs/operations/ultrasonic.svg'
import veneersImage from '../svgs/operations/veneers.svg'
import whiteningImage from '../svgs/operations/whitening.svg'
import whitening2Image from '../svgs/operations/whitening2.svg'
import whitestripsImage from '../svgs/operations/whitestrips.svg'
import xrayImage from '../svgs/operations/xray.svg'

import abscessToothImage from '../svgs/effects/abscess.jpg'
import bracessToothImage from '../svgs/effects/bracess.jpg'
import bridgeToothImage from '../svgs/effects/bridge.jpg'
import crackedToothImage from '../svgs/effects/cracked.jpg'
import crownToothImage from '../svgs/effects/crown.jpg'
import diastemaToothImage from '../svgs/effects/diastema.jpg'
import endoCrownToothImage from '../svgs/effects/endoCrown.jpg'
import extractedToothImage from '../svgs/effects/extracted.jpg'
import fractureHToothImage from '../svgs/effects/fractureH.jpg'
import fractureVToothImage from '../svgs/effects/fractureV.jpg'
import healingToothImage from '../svgs/effects/healing.jpg'
import hygToothImage from '../svgs/effects/hyg.jpg'
import implantToothImage from '../svgs/effects/implant.jpg'
import implant2ToothImage from '../svgs/effects/implant2.jpg'
import implant3ToothImage from '../svgs/effects/implant3.jpg'
import implant4ToothImage from '../svgs/effects/implant4.jpg'
import missingToothImage from '../svgs/effects/missing.jpg'
import movedLToothImage from '../svgs/effects/movedL.jpg'
import movedRToothImage from '../svgs/effects/movedR.jpg'
import pfmToothImage from '../svgs/effects/pfm.jpg'
import pfm2ToothImage from '../svgs/effects/pfm2.jpg'
import pfm2BToothImage from '../svgs/effects/pfm2B.jpg'
import pfm3ToothImage from '../svgs/effects/pfm3.jpg'
import pfm3BToothImage from '../svgs/effects/pfm3B.jpg'
import pfmBToothImage from '../svgs/effects/pfmB.jpg'
import pfm4ToothImage from '../svgs/effects/pfm4.jpg'
import pfm4BToothImage from '../svgs/effects/pfm4B.jpg'
import pfm5ToothImage from '../svgs/effects/pfm5.jpg'
import pfm5BToothImage from '../svgs/effects/pfm5B.jpg'
import pfm6ToothImage from '../svgs/effects/pfm6.jpg'
import pfm6BToothImage from '../svgs/effects/pfm6B.jpg'
import porcelainToothImage from '../svgs/effects/porcelain.jpg'
import porcelainBToothImage from '../svgs/effects/porcelainB.jpg'
import postFiberToothImage from '../svgs/effects/postFiber.jpg'
import postCoreFiberToothImage from '../svgs/effects/postCoreFiber.jpg'
import postMetalToothImage from '../svgs/effects/postMetal.jpg'
import postCoreMetalToothImage from '../svgs/effects/postCoreMetal.jpg'
import postZerconiumToothImage from '../svgs/effects/postZerconium.jpg'
import postCoreZerconiumToothImage from '../svgs/effects/postCoreZerconium.jpg'
import rctpcToothImage from '../svgs/effects/rctpc.jpg'
import recessionToothImage from '../svgs/effects/recession.jpg'
import resectionToothImage from '../svgs/effects/resection.jpg'
import resection2ToothImage from '../svgs/effects/resection2.jpg'
import rootToothImage from '../svgs/effects/root.jpg'
import rootApicectomy1ToothImage from '../svgs/effects/rootApicectomy1.jpg'
import rootApicectomy2ToothImage from '../svgs/effects/rootApicectomy2.jpg'
import rotationLToothImage from '../svgs/effects/rotationL.jpg'
import rotationRToothImage from '../svgs/effects/rotationR.jpg'
import brokenTToothImage from '../svgs/effects/brokenT.jpg'
import brokenMToothImage from '../svgs/effects/brokenM.jpg'
import brokenBToothImage from '../svgs/effects/brokenB.jpg'
import sealToothImage from '../svgs/effects/seal.jpg'
import sinusliftToothImage from '../svgs/effects/sinuslift.jpg'
import surfaceToothImage from '../svgs/effects/surface.jpg'
import veneerToothImage from '../svgs/effects/veneer.jpg'

import {
  AddictionMedicineIcon,
  AllergyAndImmunologyIcon,
  AnesthesiologyIcon,
  CardiacIcon,
  ChartIcon,
  ChiropracticIcon,
  DermatologyIcon,
  EmergencyMedicineIcon,
  EndocrinologyIcon,
  FamilyMedicineIcon,
  FullMouthIcon,
  GastroenterologyIcon,
  GastrointestinalIcon,
  GeneralSurgeryIcon,
  GeriatricsIcon,
  GynecologyIcon,
  HairTransplantIcon,
  HeartSurgeryIcon,
  HematologyIcon,
  HolisticMedicineIcon,
  ImmunizationIcon,
  InfectiousDiseaseIcon,
  InternalMedicineIcon,
  LogsIcon,
  LowerArchIcon,
  NephrologyIcon,
  NeurologyIcon,
  NeurosurgeryIcon,
  NutritionAndDieteticsIcon,
  ObstetricsIcon,
  OncologyIcon,
  OphthalmologyIcon,
  OrthopedicIcon,
  OsteoporosisIcon,
  OtolaryngologyIcon,
  PainManagementIcon,
  PediatricIcon,
  PhysicalTherapyIcon,
  PlasticSurgeryIcon,
  PodiatryIcon,
  PsychiatryIcon,
  PulmonaryFunctionTestIcon,
  PulmonologyIcon,
  RadiologyIcon,
  ReproductiveEndocrinologyIcon,
  RheumatologyIcon,
  SleepStudyIcon,
  SpeechTherapyIcon,
  SportsMedicineIcon,
  TelemedicineIcon,
  UpperArchIcon,
  UrologyIcon,
  VascularSurgeryIcon,
  VeterinaryIcon,
  WoundCareIcon
} from './icons'

const upperLeft = [
  { number: 1, perio: 1, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 1 },
  { number: 2, perio: 2, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 2 },
  { number: 3, perio: 3, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 3 },
  {
    number: 4,
    perio: 4,
    child: true,
    roots: { child: ['MB1', 'MB2', 'DB', 'P'], adult: ['L', 'P'] },

    appTooth: 4,
    childAppTooth: 1
  },
  {
    number: 5,
    perio: 5,
    child: true,
    roots: { child: ['MB1', 'MB2', 'DB', 'P'], adult: ['L', 'P'] },

    furcation: 'lower',
    appTooth: 5,
    childAppTooth: 2
  },
  { number: 6, perio: 6, child: true, roots: ['L', 'P'], appTooth: 6 },
  { number: 7, perio: 7, child: true, roots: ['L', 'P'], appTooth: 7 },
  { number: 8, perio: 8, child: true, roots: ['L', 'P'], appTooth: 8 }
]

const upperRight = [
  { number: 16, perio: 9, child: true, roots: ['L', 'P'], appTooth: 8 },
  { number: 15, perio: 10, child: true, roots: ['L', 'P'], appTooth: 7 },
  { number: 14, perio: 11, child: true, roots: ['L', 'P'], appTooth: 6 },
  {
    number: 13,
    perio: 12,
    child: true,
    roots: { child: ['MB1', 'MB2', 'DB', 'P'], adult: ['L', 'P'] },

    furcation: 'lower',
    appTooth: 5,
    childAppTooth: 2
  },
  {
    number: 12,
    perio: 13,
    child: true,
    roots: { child: ['MB1', 'MB2', 'DB', 'P'], adult: ['L', 'P'] },

    appTooth: 4,
    childAppTooth: 1
  },
  { number: 11, perio: 14, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 3 },
  { number: 10, perio: 15, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 2 },
  { number: 9, perio: 16, child: false, roots: ['MB1', 'MB2', 'DB', 'P'], furcation: 'all', appTooth: 1 }
]
const lowerLeft = [
  { number: 17, perio: 17, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 9 },
  { number: 18, perio: 18, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 10 },
  { number: 19, perio: 19, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 11 },
  {
    number: 20,
    perio: 20,
    child: true,
    roots: { child: ['MB', 'ML', 'DB', 'DL'], adult: ['B', 'L'] },

    appTooth: 12,
    childAppTooth: 9
  },
  {
    number: 21,
    perio: 21,
    child: true,
    roots: { child: ['MB', 'ML', 'DB', 'DL'], adult: ['B', 'L'] },

    appTooth: 13,
    childAppTooth: 10
  },
  { number: 22, perio: 22, child: true, roots: ['B', 'L'], appTooth: 14 },
  { number: 23, perio: 23, child: true, roots: ['B', 'L'], appTooth: 15 },
  { number: 24, perio: 24, child: true, roots: ['B', 'L'], appTooth: 16 }
]
const lowerRight = [
  { number: 32, perio: 25, child: true, roots: ['B', 'L'], appTooth: 16 },
  { number: 31, perio: 26, child: true, roots: ['B', 'L'], appTooth: 15 },
  { number: 30, perio: 27, child: true, roots: ['B', 'L'], appTooth: 14 },
  {
    number: 29,
    perio: 28,
    child: true,
    roots: { child: ['MB', 'ML', 'DB', 'DL'], adult: ['B', 'L'] },

    appTooth: 13,
    childAppTooth: 10
  },
  {
    number: 28,
    perio: 29,
    child: true,
    roots: { child: ['MB', 'ML', 'DB', 'DL'], adult: ['B', 'L'] },

    appTooth: 12,
    childAppTooth: 9
  },
  { number: 27, perio: 30, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 11 },
  { number: 26, perio: 31, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 10 },
  { number: 25, perio: 32, child: false, roots: ['MB', 'ML', 'DB', 'DL'], furcation: 'all', appTooth: 9 }
]

export const canalNames = ['MB1', 'MB2', 'DB', 'MB', 'ML', 'DL', 'B', 'L', 'P']

export const chartTeethArray = [
  {
    className: 'upper left',
    androidARClass: 'upper right',
    key: 'upperLeft',
    items: upperLeft
  },
  {
    className: 'upper right',
    androidARClass: 'upper left',
    key: 'upperRight',
    items: upperRight
  },
  {
    className: 'lower left',
    androidARClass: 'lower right',
    key: 'lowerLeft',
    items: lowerLeft
  },
  {
    className: 'lower right',
    androidARClass: 'lower left',
    key: 'lowerRight',
    items: lowerRight
  }
]

export const allToothArray = [...upperLeft, ...upperRight, ...lowerLeft, ...lowerRight]

export const perioTeethArray = [
  {
    className: 'perio_buccal',
    type: 'Buccal',
    lower: false,
    buccal: true,
    items: [
      {
        className: 'left perio buccal',
        key: 'perio_buccal',
        items: upperLeft
      },
      {
        className: 'right perio buccal',
        key: 'perio_buccal',
        items: upperRight
      }
    ]
  },
  {
    className: 'lower_perio_lingual',
    type: 'Lingual',
    lower: true,
    buccal: false,
    items: [
      {
        className: 'lower left perio lingual',
        key: 'lower_perio_lingual',
        items: upperLeft
      },
      {
        className: 'lower right perio lingual',
        key: 'lower_perio_lingual',
        items: upperRight
      }
    ]
  },
  {
    className: 'perio_lingual',
    type: 'Lingual',
    lower: false,
    buccal: false,
    items: [
      {
        className: 'left perio lingual',
        key: 'perio_lingual',
        items: lowerLeft
      },
      {
        className: 'right perio lingual',
        key: 'perio_lingual',
        items: lowerRight
      }
    ]
  },
  {
    className: 'lower_perio_buccal',
    type: 'Buccal',
    lower: true,
    buccal: true,
    items: [
      {
        className: 'lower left perio buccal',
        key: 'lower_perio_buccal',
        items: lowerLeft
      },
      {
        className: 'lower right perio buccal',
        key: 'lower_perio_buccal',
        items: lowerRight
      }
    ]
  }
]

export const teethChartNumbers = [
  {
    PALMER: { adult: 8, child: 8 },
    ALPHANUMERIC: { adult: 'UR8', child: 'UR8' },
    FDI: { adult: 18, child: 18 },
    UNIVERSAL: { adult: 1, child: 1 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: '', child: '' }, sup: { adult: 3, child: 3 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 7, child: 7 },
    ALPHANUMERIC: { adult: 'UR7', child: 'UR7' },
    FDI: { adult: 17, child: 17 },
    UNIVERSAL: { adult: 2, child: 2 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: '', child: '' }, sup: { adult: 2, child: 2 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 6, child: 6 },
    ALPHANUMERIC: { adult: 'UR6', child: 'UR6' },
    FDI: { adult: 16, child: 16 },
    UNIVERSAL: { adult: 3, child: 3 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: '', child: '' }, sup: { adult: 1, child: 1 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 5, child: 'E' },
    ALPHANUMERIC: { adult: 'UR5', child: 'URE' },
    FDI: { adult: 15, child: 55 },
    UNIVERSAL: { adult: 4, child: 'A' },
    PALEOANTHROPOLOGY: { adult: 'RP', child: 'RM', sub: { adult: '', child: '' }, sup: { adult: 4, child: 2 } },
    roots: ['r1_rb1', 'r2_rb1']
  },
  {
    PALMER: { adult: 4, child: 'D' },
    ALPHANUMERIC: { adult: 'UR4', child: 'URD' },
    FDI: { adult: 14, child: 54 },
    UNIVERSAL: { adult: 5, child: 'B' },
    PALEOANTHROPOLOGY: { adult: 'RP', child: 'RM', sub: { adult: '', child: '' }, sup: { adult: 3, child: 1 } },
    roots: ['r1_rb1', 'r2_rb1']
  },
  {
    PALMER: { adult: 3, child: 'C' },
    ALPHANUMERIC: { adult: 'UR3', child: 'URC' },
    FDI: { adult: 13, child: 53 },
    UNIVERSAL: { adult: 6, child: 'C' },
    PALEOANTHROPOLOGY: { adult: 'RC', child: 'RC', sub: { adult: '', child: '' }, sup: { adult: '-', child: '-' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 2, child: 'B' },
    ALPHANUMERIC: { adult: 'UR2', child: 'URB' },
    FDI: { adult: 12, child: 52 },
    UNIVERSAL: { adult: 7, child: 'D' },
    PALEOANTHROPOLOGY: { adult: 'RI', child: 'RI', sub: { adult: '', child: '' }, sup: { adult: 2, child: 2 } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 1, child: 'A' },
    ALPHANUMERIC: { adult: 'UR1', child: 'URA' },
    FDI: { adult: 11, child: 51 },
    UNIVERSAL: { adult: 8, child: 'E' },
    PALEOANTHROPOLOGY: { adult: 'RI', child: 'RI', sub: { adult: '', child: '' }, sup: { adult: 1, child: 1 } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 8, child: 8 },
    ALPHANUMERIC: { adult: 'UL8', child: 'UL8' },
    FDI: { adult: 28, child: 28 },
    UNIVERSAL: { adult: 16, child: 16 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: '', child: '' }, sup: { adult: 3, child: 3 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 7, child: 7 },
    ALPHANUMERIC: { adult: 'UL7', child: 'UL7' },
    FDI: { adult: 27, child: 27 },
    UNIVERSAL: { adult: 15, child: 15 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: '', child: '' }, sup: { adult: 2, child: 2 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 6, child: 6 },
    ALPHANUMERIC: { adult: 'UL6', child: 'UL6' },
    FDI: { adult: 26, child: 26 },
    UNIVERSAL: { adult: 14, child: 14 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: '', child: '' }, sup: { adult: 1, child: 1 } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb3']
  },
  {
    PALMER: { adult: 5, child: 'E' },
    ALPHANUMERIC: { adult: 'UL5', child: 'ULE' },
    FDI: { adult: 25, child: 65 },
    UNIVERSAL: { adult: 13, child: 'J' },
    PALEOANTHROPOLOGY: { adult: 'LP', child: 'LM', sub: { adult: '', child: '' }, sup: { adult: 4, child: 2 } },
    roots: ['r1_rb1', 'r2_rb1']
  },
  {
    PALMER: { adult: 4, child: 'D' },
    ALPHANUMERIC: { adult: 'UL4', child: 'ULD' },
    FDI: { adult: 24, child: 64 },
    UNIVERSAL: { adult: 12, child: 'I' },
    PALEOANTHROPOLOGY: { adult: 'LP', child: 'LM', sub: { adult: '', child: '' }, sup: { adult: 3, child: 1 } },
    roots: ['r1_rb1', 'r2_rb1']
  },
  {
    PALMER: { adult: 3, child: 'C' },
    ALPHANUMERIC: { adult: 'UL3', child: 'ULC' },
    FDI: { adult: 23, child: 63 },
    UNIVERSAL: { adult: 11, child: 'H' },
    PALEOANTHROPOLOGY: { adult: 'LC', child: 'LC', sub: { adult: '', child: '' }, sup: { adult: '-', child: '-' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 2, child: 'B' },
    ALPHANUMERIC: { adult: 'UL2', child: 'ULB' },
    FDI: { adult: 22, child: 62 },
    UNIVERSAL: { adult: 10, child: 'G' },
    PALEOANTHROPOLOGY: { adult: 'LI', child: 'LI', sub: { adult: '', child: '' }, sup: { adult: 2, child: 2 } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 1, child: 'A' },
    ALPHANUMERIC: { adult: 'UL1', child: 'ULA' },
    FDI: { adult: 21, child: 61 },
    UNIVERSAL: { adult: 9, child: 'F' },
    PALEOANTHROPOLOGY: { adult: 'LI', child: 'LI', sub: { adult: '', child: '' }, sup: { adult: 1, child: 1 } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 8, child: 8 },
    ALPHANUMERIC: { adult: 'LR8', child: 'LR8' },
    FDI: { adult: 48, child: 48 },
    UNIVERSAL: { adult: 32, child: 32 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: 3, child: 3 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb2']
  },
  {
    PALMER: { adult: 7, child: 7 },
    ALPHANUMERIC: { adult: 'LR7', child: 'LR7' },
    FDI: { adult: 47, child: 47 },
    UNIVERSAL: { adult: 31, child: 31 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: 2, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb1', 'r3_rb2']
  },
  {
    PALMER: { adult: 6, child: 6 },
    ALPHANUMERIC: { adult: 'LR6', child: 'LR6' },
    FDI: { adult: 46, child: 46 },
    UNIVERSAL: { adult: 30, child: 30 },
    PALEOANTHROPOLOGY: { adult: 'RM', child: 'RM', sub: { adult: 1, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb2']
  },
  {
    PALMER: { adult: 5, child: 'E' },
    ALPHANUMERIC: { adult: 'LR5', child: 'LRE' },
    FDI: { adult: 45, child: 85 },
    UNIVERSAL: { adult: 29, child: 'T' },
    PALEOANTHROPOLOGY: { adult: 'RP', child: 'RM', sub: { adult: 4, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 4, child: 'D' },
    ALPHANUMERIC: { adult: 'LR4', child: 'LRD' },
    FDI: { adult: 44, child: 84 },
    UNIVERSAL: { adult: 28, child: 'S' },
    PALEOANTHROPOLOGY: { adult: 'RP', child: 'RM', sub: { adult: 3, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 3, child: 'C' },
    ALPHANUMERIC: { adult: 'LR3', child: 'LRC' },
    FDI: { adult: 43, child: 83 },
    UNIVERSAL: { adult: 27, child: 'R' },
    PALEOANTHROPOLOGY: { adult: 'RC', child: 'RC', sub: { adult: '-', child: '-' }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 2, child: 'B' },
    ALPHANUMERIC: { adult: 'LR2', child: 'LRB' },
    FDI: { adult: 42, child: 82 },
    UNIVERSAL: { adult: 26, child: 'Q' },
    PALEOANTHROPOLOGY: { adult: 'RI', child: 'RI', sub: { adult: 2, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 1, child: 'A' },
    ALPHANUMERIC: { adult: 'LR1', child: 'LRA' },
    FDI: { adult: 41, child: 81 },
    UNIVERSAL: { adult: 25, child: 'P' },
    PALEOANTHROPOLOGY: { adult: 'RI', child: 'RI', sub: { adult: 1, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 8, child: 8 },
    ALPHANUMERIC: { adult: 'LL8', child: 'LL8' },
    FDI: { adult: 38, child: 38 },
    UNIVERSAL: { adult: 17, child: 17 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: 3, child: 3 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb2']
  },
  {
    PALMER: { adult: 7, child: 7 },
    ALPHANUMERIC: { adult: 'LL7', child: 'LL7' },
    FDI: { adult: 37, child: 37 },
    UNIVERSAL: { adult: 18, child: 18 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: 2, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb1', 'r3_rb2']
  },
  {
    PALMER: { adult: 6, child: 6 },
    ALPHANUMERIC: { adult: 'LL6', child: 'LL6' },
    FDI: { adult: 36, child: 36 },
    UNIVERSAL: { adult: 19, child: 19 },
    PALEOANTHROPOLOGY: { adult: 'LM', child: 'LM', sub: { adult: 1, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1', 'r2_rb2', 'r3_rb2']
  },
  {
    PALMER: { adult: 5, child: 'E' },
    ALPHANUMERIC: { adult: 'LL5', child: 'LLE' },
    FDI: { adult: 35, child: 75 },
    UNIVERSAL: { adult: 20, child: 'K' },
    PALEOANTHROPOLOGY: { adult: 'LP', child: 'LM', sub: { adult: 4, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 4, child: 'D' },
    ALPHANUMERIC: { adult: 'LL4', child: 'LLD' },
    FDI: { adult: 34, child: 74 },
    UNIVERSAL: { adult: 21, child: 'L' },
    PALEOANTHROPOLOGY: { adult: 'LP', child: 'LM', sub: { adult: 3, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 3, child: 'C' },
    ALPHANUMERIC: { adult: 'LL3', child: 'LLC' },
    FDI: { adult: 33, child: 73 },
    UNIVERSAL: { adult: 22, child: 'M' },
    PALEOANTHROPOLOGY: { adult: 'LC', child: 'LC', sub: { adult: '-', child: '-' }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 2, child: 'B' },
    ALPHANUMERIC: { adult: 'LL2', child: 'LLB' },
    FDI: { adult: 32, child: 72 },
    UNIVERSAL: { adult: 23, child: 'N' },
    PALEOANTHROPOLOGY: { adult: 'LI', child: 'LI', sub: { adult: 2, child: 2 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  },
  {
    PALMER: { adult: 1, child: 'A' },
    ALPHANUMERIC: { adult: 'LL1', child: 'LLA' },
    FDI: { adult: 31, child: 71 },
    UNIVERSAL: { adult: 24, child: 'O' },
    PALEOANTHROPOLOGY: { adult: 'LI', child: 'LI', sub: { adult: 1, child: 1 }, sup: { adult: '', child: '' } },
    roots: ['r1_rb1']
  }
]

export const teethNumbersForAdultsAndChildren = {
  adult: {
    upper: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
    lower: [17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],
    upperLeft: [1, 2, 3, 4, 5, 6, 7, 8],
    upperRight: [16, 15, 14, 13, 12, 11, 10, 9],
    lowerLeft: [17, 18, 19, 20, 21, 22, 23, 24],
    lowerRight: [32, 31, 30, 29, 28, 27, 26, 25]
  },
  child: {
    upper: [4, 5, 6, 7, 8, 12, 13, 14, 15, 16],
    lower: [20, 21, 22, 23, 24, 28, 29, 30, 31, 32],
    upperLeft: [4, 5, 6, 7, 8],
    upperRight: [16, 15, 14, 13, 12],
    lowerLeft: [20, 21, 22, 23, 24],
    lowerRight: [32, 31, 30, 29, 28]
  }
}

export const adultTeethUpperOnly = [1, 2, 3, 9, 10, 11]
export const adultTeethLowerOnly = [17, 18, 19, 25, 26, 27]

export const proceduresImages = {
  anast: anestheticImage,
  crown: crownImage,
  diag: forumImage,
  ext: extractionImage,
  hyg: hygieneImage,
  imp: implantImage,
  ortho: bracesImage,
  rct: rootImage,
  resto: perfectImage,
  watch: onlineImage,
  whit: whitening2Image,
  xray: xrayImage,
  appointment: appointmentImage,
  babyTeeth: babyTeethImage,
  bacteria: bacteriaImage,
  badBreath: badBreathImage,
  bonding: bondingImage,
  brokenTooth: brokenToothImage,
  calculus: calculusImage,
  contact: contactImage,
  crowning: crowningImage,
  crowning2: crowning2Image,
  dentist: dentistImage,
  dentures: denturesImage,
  details: detailsImage,
  enamel: enamelImage,
  family: familyImage,
  floss: flossImage,
  gap: gapImage,
  led: ledImage,
  location: locationImage,
  missing: missingImage,
  mobile: mobileImage,
  mouthWash: mouthWashImage,
  oralCavity: oralCavityImage,
  oralIrrigator: oralIrrigatorImage,
  protection: protectionImage,
  record: recordImage,
  rotten: rottenImage,
  scaling: scalingImage,
  service: serviceImage,
  sleeping: sleepingImage,
  smile: smileImage,
  snoring: snoringImage,
  toolkit: toolkitImage,
  toothache: toothacheImage,
  toothbursh: toothburshImage,
  toothpaste: toothpasteImage,
  ultrasonic: ultrasonicImage,
  veneers: veneersImage,
  whitening: whiteningImage,
  whitestrips: whitestripsImage
}

export const proceduresToothImages = {
  bridge: { title: 'Bridge', image: bridgeToothImage },
  crown: { title: 'Crown', image: crownToothImage },
  endoCrown: { title: 'Endo Crown', image: endoCrownToothImage },
  implant: { title: 'Implant 1', image: implantToothImage },
  implant2: { title: 'Implant 2', image: implant2ToothImage },
  implant3: { title: 'Implant 3', image: implant3ToothImage },
  implant4: { title: 'Implant 4', image: implant4ToothImage },
  pfm: { title: 'PFM 1', image: pfmToothImage },
  pfmB: { title: 'PFM 1 Bridge', image: pfmBToothImage },
  pfm2: { title: 'PFM 2', image: pfm2ToothImage },
  pfm2B: { title: 'PFM 2 Bridge', image: pfm2BToothImage },
  pfm3: { title: 'Zirconium', image: pfm3ToothImage },
  pfm3B: { title: 'Zirconium Bridge', image: pfm3BToothImage },
  pfm4: { title: 'Zirconium 2', image: pfm4ToothImage },
  pfm4B: { title: 'Zirconium 2 Bridge', image: pfm4BToothImage },
  pfm5: { title: 'E-Max', image: pfm5ToothImage },
  pfm5B: { title: 'E-Max Bridge', image: pfm5BToothImage },
  pfm6: { title: 'PFM 3', image: pfm6ToothImage },
  pfm6B: { title: 'PFM 3 Bridge', image: pfm6BToothImage },
  porcelain: { title: 'Porcelain', image: porcelainToothImage },
  porcelainB: { title: 'Porcelain Bridge', image: porcelainBToothImage },
  healing: { title: 'Healing Abutment', image: healingToothImage },
  hyg: { title: 'Hygiene', image: hygToothImage },
  postFiber: { title: 'Fiber Post', image: postFiberToothImage },
  postCoreFiber: { title: 'Fiber Post & Core', image: postCoreFiberToothImage },
  postMetal: { title: 'Metal Post', image: postMetalToothImage },
  postCoreMetal: { title: 'Metal Post & Core', image: postCoreMetalToothImage },
  postZerconium: { title: 'Zirconium Post', image: postZerconiumToothImage },
  postCoreZerconium: { title: 'Zirconium Post & Core', image: postCoreZerconiumToothImage },
  rctpc: { title: 'Core', image: rctpcToothImage },
  resection: { title: 'Tooth Resection', image: resectionToothImage },
  resection2: { title: 'Tooth Resection 2', image: resection2ToothImage },
  root: { title: 'Root Canal', image: rootToothImage },
  rootApicectomy1: { title: 'Root Apicectomy 1', image: rootApicectomy1ToothImage },
  rootApicectomy2: { title: 'Root Apicectomy 2', image: rootApicectomy2ToothImage },
  seal: { title: 'Seal', image: sealToothImage },
  sinuslift: { title: 'Sinuslift', image: sinusliftToothImage },
  surface: { title: 'Surface', image: surfaceToothImage },
  veneer: { title: 'Veneer', image: veneerToothImage },
  abscess: { title: 'Abscess', image: abscessToothImage },
  bracess: { title: 'Bracket', image: bracessToothImage },
  extracted: { title: 'Extracted', image: extractedToothImage },
  missing: { title: 'Missing', image: missingToothImage },
  cracked: { title: 'Cracked', image: crackedToothImage },
  recession: { title: 'Recession', image: recessionToothImage },
  diastema: { title: 'Diastema', image: diastemaToothImage },
  fractureH: { title: 'Fracture H', image: fractureHToothImage },
  fractureV: { title: 'Fracture V', image: fractureVToothImage },
  movedL: { title: 'Moved Distal', image: movedLToothImage },
  movedR: { title: 'Moved Mesial', image: movedRToothImage },
  rotationL: { title: 'Rotation Distal', image: rotationLToothImage },
  rotationR: { title: 'Rotation Mesial', image: rotationRToothImage },
  brokenT: { title: 'Broken Coronal', image: brokenTToothImage },
  brokenM: { title: 'Broken Middle', image: brokenMToothImage },
  brokenB: { title: 'Broken Apical', image: brokenBToothImage }
}

export const operationsStatusColors = {
  PLANNED: '#FF4838',
  COMPLETED: '#00b050',
  IN_PROGRESS: '#3786cd',
  REJECTED: '#9b37cd',
  EXISTING: '#50575e',
  PLANNED_faded: '#e39197',
  COMPLETED_faded: '#79b494',
  IN_PROGRESS_faded: '#6d9bc6',
  REJECTED_faded: '#a86dc6',
  EXISTING_faded: '#8f9193',
  PLANNED_dark: '#a80101',
  COMPLETED_dark: '#00802b',
  IN_PROGRESS_dark: '#005380',
  REJECTED_dark: '#730080',
  EXISTING_dark: '#606566'
}

export const DHSApprovalStatusColors = {
  PENDING: '#3786cd',
  APPROVED: '#00b050',
  PARTIALLY_APPROVED: '#00b050',
  REJECTED: '#9b37cd',
  CANCELED: '#50575e',
  ERROR: '#FF4838',
  NULL: '#8f9193'
}

export const toothTargetIds = ['l', 'b', 'dl', 'd', 'db', 'o', 'ml', 'm', 'mb', 'rb3', 'rb2', 'rb1', 'r3', 'r2', 'r1']
const surfaceIds = ['l', 'b', 'dl', 'd', 'db', 'o', 'ml', 'm', 'mb']
const rootIds = ['rb3', 'rb2', 'rb1', 'r3', 'r2', 'r1']

export const patientAgeGroups = ['ALL', 'ADULT', 'CHILD']

export const dentalNotations = [
  { value: 'PALMER', label: 'Palmer' },
  { value: 'FDI', label: 'FDI (ISO 3950)' },
  { value: 'UNIVERSAL', label: 'Universal' },
  { value: 'ALPHANUMERIC', label: 'Alphanumeric' },
  { value: 'PALEOANTHROPOLOGY', label: 'Paleoanthropology' }
]

export const getToothEffect = (operation, toothNumber) => {
  let effect
  let toothEffect
  if (operation.procedure && operation.procedure.toothEffect) {
    effect = `${operation.procedure.toothEffect}_${operation.status}`
    toothEffect = operation.procedure.toothEffect
  } else if (operation.condition && operation.condition.toothEffect) {
    effect = `${operation.condition.toothEffect}_EXISTING`
    toothEffect = operation.condition.toothEffect
  }
  if (
    operation.toothPart.filter(t => !!t).length &&
    effect &&
    !(toothEffect === 'surface' && !operation.toothPart.find(t => surfaceIds.includes(t))) &&
    !(toothEffect === 'rootApicectomy1' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'rootApicectomy2' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'brokenM' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'brokenT' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'brokenB' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postFiber' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postMetal' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postZerconium' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postCoreFiber' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postCoreMetal' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'postCoreZerconium' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'fractureH' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'fractureV' && !operation.toothPart.find(t => rootIds.includes(t))) &&
    !(toothEffect === 'root' && !operation.toothPart.find(t => rootIds.includes(t)))
  ) {
    effect = `${effect} ${operation.toothPart
      .filter(
        (toothPart, i) =>
          operation.tooth[i] === toothNumber ||
          (!operation.tooth[i] && surfaceIds.includes(toothPart)) ||
          (!operation.tooth[i] && rootIds.includes(toothPart))
      )
      .map(toothPart => {
        if (toothPart) {
          if (['rootApicectomy1', 'rootApicectomy2'].includes(toothEffect)) {
            let updatedToothParts = [toothPart]
            let updatedToothRoots = []
            if (
              teethChartNumbers[toothNumber - 1].roots.find(s => s.startsWith(toothPart)) ||
              teethChartNumbers[toothNumber - 1].roots.find(s => s.endsWith(toothPart))
            ) {
              const canal = teethChartNumbers[toothNumber - 1].roots
                .find(s => s.startsWith(toothPart) || s.endsWith(toothPart))
                .split('_')[1]
              updatedToothParts = teethChartNumbers[toothNumber - 1].roots
                .filter(s => s.endsWith(canal))
                .map(s => s.split('_')[0])
              updatedToothRoots = teethChartNumbers[toothNumber - 1].roots
                .filter(s => s.endsWith(canal))
                .map(s => s.split('_')[1])
            }

            return [
              ...new Set([...updatedToothParts.map(s => `${s}_${effect}`), ...updatedToothRoots.map(s => `${s}_${effect}`)])
            ].join(' ')
          }

          if (
            toothPart === 'rb2' &&
            [
              'brokenM',
              'brokenT',
              'brokenB',
              'postFiber',
              'postMetal',
              'postZerconium',
              'postCoreFiber',
              'postCoreMetal',
              'postCoreZerconium'
            ].includes(toothEffect) &&
            [18, 26].includes(toothNumber)
          ) {
            return `r3_${effect}`
          } else if (
            ['postFiber', 'postMetal', 'postZerconium', 'postCoreFiber', 'postCoreMetal', 'postCoreZerconium'].includes(
              toothEffect
            ) &&
            [6, 7, 8, 14, 15, 16, 20, 21, 22, 23, 24, 28, 29, 30, 31, 32].includes(toothNumber)
          ) {
            return `rb2_${effect}`
          }
          return `${toothPart}_${effect}`
        }

        return ''
      })
      .join(' ')}`
  } else if (
    [
      'surface',
      'root',
      'fractureH',
      'fractureV',
      'postFiber',
      'postMetal',
      'postZerconium',
      'rootApicectomy1',
      'rootApicectomy2',
      'postCoreFiber',
      'postCoreMetal',
      'postCoreZerconium',
      'brokenM',
      'brokenT',
      'brokenB'
    ].includes(toothEffect)
  ) {
    effect = `${effect} ${toothEffect === 'surface' ? `o_${effect}` : `r1_${effect} r3_${effect} r2_${effect}`}`
  }
  return effect
}

export const chartTypes = [
  { name: 'Dental', value: 'DENTAL', icon: <ChartIcon /> },
  {
    name: 'Cardiologist',
    value: 'CARDIAC',
    icon: <CardiacIcon />,
    hasPackage: true,
    rootCanals: ['DCD', 'Area', 'Spot Size', 'Fluence']
  },
  {
    name: 'Neurologist',
    value: 'NEUROLOGY',
    icon: <NeurologyIcon />,
    hasPackage: true,
    rootCanals: ['DCD', 'Area', 'Spot Size', 'Fluence']
  },
  {
    name: 'Dermatologist',
    value: 'DERMATOLOGY',
    icon: <DermatologyIcon />,
    hasPackage: true,
    rootCanals: ['DCD', 'Area', 'Spot Size', 'Fluence']
  },
  { name: 'Gastroenterologist', hasPackage: true, value: 'GASTROINTESTINAL', icon: <GastrointestinalIcon /> },
  { name: 'Ophthalmologist', hasPackage: true, value: 'OPHTHALMOLOGY', icon: <OphthalmologyIcon /> },
  { name: 'Orthopedic Surgeon', hasPackage: true, value: 'ORTHOPEDIC', icon: <OrthopedicIcon /> },
  { name: 'Obstetrician', hasPackage: true, value: 'OBSTETRICS', icon: <ObstetricsIcon /> },
  { name: 'Pediatrician', hasPackage: true, value: 'PEDIATRIC', icon: <PediatricIcon /> },
  { name: 'Pulmonologist', hasPackage: true, value: 'PULMONOLOGY', icon: <PulmonologyIcon /> },
  { name: 'Urologist', hasPackage: true, value: 'UROLOGY', icon: <UrologyIcon /> },
  { name: 'Hematologist', hasPackage: true, value: 'HEMATOLOGY', icon: <HematologyIcon /> },
  { name: 'Endocrinologist', hasPackage: true, value: 'ENDOCRINOLOGY', icon: <EndocrinologyIcon /> },
  { name: 'Rheumatologist', hasPackage: true, value: 'RHEUMATOLOGY', icon: <RheumatologyIcon /> },
  { name: 'Nephrologist', hasPackage: true, value: 'NEPHROLOGY', icon: <NephrologyIcon /> },
  { name: 'Gynecologist', hasPackage: true, value: 'GYNECOLOGY', icon: <GynecologyIcon /> },
  { name: 'Allergist/Immunologist', hasPackage: true, value: 'ALLERGY_AND_IMMUNOLOGY', icon: <AllergyAndImmunologyIcon /> },
  { name: 'Infectious Disease Specialist', hasPackage: true, value: 'INFECTIOUS_DISEASE', icon: <InfectiousDiseaseIcon /> },
  { name: 'Plastic Surgeon', hasPackage: true, value: 'PLASTIC_SURGERY', icon: <PlasticSurgeryIcon /> },
  { name: 'Vascular Surgeon', hasPackage: true, value: 'VASCULAR_SURGERY', icon: <VascularSurgeryIcon /> },
  { name: 'General Surgery', hasPackage: true, value: 'GENERAL_SURGERY', icon: <GeneralSurgeryIcon /> },
  { name: 'Gastroenterology', hasPackage: true, value: 'GASTROENTEROLOGY', icon: <GastroenterologyIcon /> },
  { name: 'Internal Medicine', hasPackage: true, value: 'INTERNAL_MEDICINE', icon: <InternalMedicineIcon /> },
  { name: 'Heart Surgery', hasPackage: true, value: 'HEART_SURGERY', icon: <HeartSurgeryIcon /> },
  { name: 'Heart Examinations', hasPackage: true, value: 'HEART_EXAMINATIONS', icon: <HeartSurgeryIcon /> },
  { name: 'Hair Transplant', hasPackage: true, value: 'HAIR_TRANSPLANT', icon: <HairTransplantIcon /> },
  { name: 'Neurosurgeon', hasPackage: true, value: 'NEUROSURGERY', icon: <NeurosurgeryIcon /> },
  { name: 'Podiatrist', hasPackage: true, value: 'PODIATRY', icon: <PodiatryIcon /> },
  { name: 'Radiologist', hasPackage: true, value: 'RADIOLOGY', icon: <RadiologyIcon /> },
  { name: 'Psychiatrist', hasPackage: true, value: 'PSYCHIATRY', icon: <PsychiatryIcon /> },
  { name: 'Otolaryngologist', hasPackage: true, value: 'OTOLARYNGOLOGY', icon: <OtolaryngologyIcon /> },
  { name: 'Oncologist', hasPackage: true, value: 'ONCOLOGY', icon: <OncologyIcon /> },
  { name: 'Anesthesiologist', hasPackage: true, value: 'ANESTHESIOLOGY', icon: <AnesthesiologyIcon /> },
  { name: 'Physical Therapist', hasPackage: true, value: 'PHYSICAL_THERAPY', icon: <PhysicalTherapyIcon /> },
  {
    name: 'Pulmonary Function Specialist',
    hasPackage: true,
    value: 'PULMONARY_FUNCTION_TEST',
    icon: <PulmonaryFunctionTestIcon />
  },
  { name: 'Osteopath', hasPackage: true, value: 'OSTEOPOROSIS', icon: <OsteoporosisIcon /> },
  { name: 'Sleep Specialist', hasPackage: true, value: 'SLEEP_STUDY', icon: <SleepStudyIcon /> },
  { name: 'Geriatrician', hasPackage: true, value: 'GERIATRICS', icon: <GeriatricsIcon /> },
  { name: 'Family Physician', hasPackage: true, value: 'FAMILY_MEDICINE', icon: <FamilyMedicineIcon /> },
  { name: 'Emergency Medicine Physician', hasPackage: true, value: 'EMERGENCY_MEDICINE', icon: <EmergencyMedicineIcon /> },
  { name: 'Sports Medicine Physician', hasPackage: true, value: 'SPORTS_MEDICINE', icon: <SportsMedicineIcon /> },
  { name: 'Pain Management Specialist', hasPackage: true, value: 'PAIN_MANAGEMENT', icon: <PainManagementIcon /> },
  { name: 'Dietitian/Nutritionist', hasPackage: true, value: 'NUTRITION_AND_DIETETICS', icon: <NutritionAndDieteticsIcon /> },
  { name: 'Speech Therapist', hasPackage: true, value: 'SPEECH_THERAPY', icon: <SpeechTherapyIcon /> },
  { name: 'Wound Care Specialist', hasPackage: true, value: 'WOUND_CARE', icon: <WoundCareIcon /> },
  { name: 'Chiropractor', hasPackage: true, value: 'CHIROPRACTIC', icon: <ChiropracticIcon /> },
  { name: 'Holistic Medicine Practitioner', hasPackage: true, value: 'HOLISTIC_MEDICINE', icon: <HolisticMedicineIcon /> },
  { name: 'Addiction Medicine Specialist', hasPackage: true, value: 'ADDICTION_MEDICINE', icon: <AddictionMedicineIcon /> },
  { name: 'Immunologist', hasPackage: true, value: 'IMMUNIZATION', icon: <ImmunizationIcon /> },
  {
    name: 'Reproductive Endocrinologist',
    hasPackage: true,
    value: 'REPRODUCTIVE_ENDOCRINOLOGY',
    icon: <ReproductiveEndocrinologyIcon />
  },
  {
    name: 'Special Needs',
    hasPackage: true,
    value: 'SPECIAL_NEEDS',
    icon: <FamilyMedicineIcon />
  },
  { name: 'Telemedicine Provider', hasPackage: true, value: 'TELEMEDICINE', icon: <TelemedicineIcon /> },
  { name: 'Veterinary Provider', hasPackage: true, value: 'VETERINARY', icon: <VeterinaryIcon /> },
  { name: 'Pediatric Surgery', hasPackage: true, value: 'PEDIATRIC_SURGERY', icon: <PediatricIcon /> },
  { name: 'Surgical Oncology', hasPackage: true, value: 'SURGICAL_ONCOLOGY', icon: <OncologyIcon /> },
  { name: 'Spine Surgery', hasPackage: true, value: 'SPINE_SURGERY', icon: <OrthopedicIcon /> },
  { name: 'Bariatric Surgery', hasPackage: true, value: 'BARIATRIC_SURGERY', icon: <GeneralSurgeryIcon /> },
  {
    name: 'IVF And Assisted Reproduction',
    hasPackage: true,
    value: 'IVF_AND_ASSISTED_REPRODUCTION',
    icon: <ReproductiveEndocrinologyIcon />
  },
  { name: 'Andrology And Male Infertility', hasPackage: true, value: 'ANDROLOGY_AND_MALE_INFERTILITY', icon: <UrologyIcon /> },
  { name: 'Hepatology', hasPackage: true, value: 'HEPATOLOGY', icon: <GastroenterologyIcon /> },
  { name: 'Medical Laboratory', hasPackage: true, value: 'MEDICAL_LABORATORY', icon: <RadiologyIcon /> },
  { name: 'Colorectal Surgery', hasPackage: true, value: 'COLORECTAL_SURGERY', icon: <GeneralSurgeryIcon /> },
  { name: 'Occupational Therapy', hasPackage: true, value: 'OCCUPATIONAL_THERAPY', icon: <PhysicalTherapyIcon /> },
  { name: 'Pediatric Physical Therapy', hasPackage: true, value: 'PEDIATRIC_PHYSICAL_THERAPY', icon: <PhysicalTherapyIcon /> },
  { name: 'Not Applicable', value: 'NA', icon: <LogsIcon /> }
]

export const fileModels = [
  { value: 'patient', title: 'calendar.patient' },
  { value: 'user', title: 'settings.expenses.user' },
  { value: 'insuranceCompany', title: 'settings.insurance.insuranceCompanies' },
  { value: 'supplier', title: 'app.suppliers' },
  { value: 'lab', title: 'app.labs' },
  { value: 'invoice', title: 'patients.invoice' },
  { value: 'expense', title: 'sidebar.expenses' },
  { value: 'income', title: 'sidebar.income' },
  { value: 'treasury', title: 'app.treasury' }
]

export const toothShades = [
  'A1',
  'A2',
  'A3',
  'A3.5',
  'A4',
  'B1',
  'B2',
  'B3',
  'B4',
  'C1',
  'C2',
  'C3',
  'C4',
  'D2',
  'D3',
  'D4',
  '1M1',
  '3R1.5',
  '3M2',
  '3R2.5',
  '4R1.5',
  '2M1',
  '2M2',
  '3M3',
  '4L2.5',
  '2R1.5',
  '3L1.5',
  '4M1',
  '4L1.5',
  '4M2',
  '5M1',
  '5M2',
  '3M1',
  '1M2',
  '2L1.5',
  '2L2.5',
  '2R2.5',
  '2M3',
  '3L2.5',
  '4M3',
  '5M3',
  'OM2',
  'OM3',
  'OM1'
]

export const toothSurfaceNumbers = [
  { tooth: 100, title: 'mouth', icon: <FullMouthIcon /> },
  { tooth: 99, title: 'upper', icon: <UpperArchIcon /> },
  { tooth: 98, title: 'lower', icon: <LowerArchIcon /> }
]

export const EMPTY_ITEM_NAME = '_Empty'

export const canalMeasurements = {
  Fluence: 'Jul',
  'Spot Size': 'mm'
}
